import axios from "axios";

const API = axios.create({
  baseURL: "https://api.kestren.com/api",
});

// 🔐 Add Token in Every Request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 🔥 Detect Token Expiry, Force Logout
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      alert("Session expired. Please login again.");

      // Remove token
      localStorage.removeItem("token");

      // Redirect user
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default API;
